var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { staticClass: "partner-label-form" },
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("Tool.PartnerCategory") } },
        [
          _c(
            "el-select",
            {
              model: {
                value: _vm.currentKey,
                callback: function($$v) {
                  _vm.currentKey = $$v
                },
                expression: "currentKey"
              }
            },
            _vm._l(_vm.partnerConfigList, function(item) {
              return _c("el-option", {
                key: item.autoKey,
                attrs: {
                  value: item.autoKey,
                  label: _vm.isZh ? item.autoName : item.autoEnglishName
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-radio-group",
            {
              on: { change: _vm.labelChange },
              model: {
                value: _vm.currentLabel,
                callback: function($$v) {
                  _vm.currentLabel = $$v
                },
                expression: "currentLabel"
              }
            },
            [
              _vm.currentKey === "auto_office"
                ? [
                    _c(
                      "el-radio",
                      {
                        staticStyle: { "margin-right": "15px" },
                        attrs: { label: "chineseName" }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BranchCnName")))]
                    ),
                    _c(
                      "el-radio",
                      {
                        staticStyle: { "margin-right": "15px" },
                        attrs: { label: "englishName" }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BranchEnName")))]
                    ),
                    _c("el-radio", { attrs: { label: "code" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BranchCode")))
                    ])
                  ]
                : _vm.currentKey === "auto_paymentTerm"
                ? [
                    _c("el-radio", { attrs: { label: "code" } }, [
                      _vm._v(_vm._s(_vm.$t("Tool.Code")))
                    ]),
                    _c("el-radio", { attrs: { label: "name" } }, [
                      _vm._v(_vm._s(_vm.$t("Tool.Name")))
                    ]),
                    _c("el-radio", { attrs: { label: "codePlusName" } }, [
                      _vm._v(_vm._s(_vm.isZh ? "代码+名称" : "Code + Name"))
                    ]),
                    _c("el-radio", { attrs: { label: "localName" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LocalizedName")))
                    ])
                  ]
                : [
                    _c("el-radio", { attrs: { label: "chineseName" } }, [
                      _vm._v(_vm._s(_vm.$t("Tool.Chinese")))
                    ]),
                    _c("el-radio", { attrs: { label: "englishName" } }, [
                      _vm._v(_vm._s(_vm.$t("Tool.English")))
                    ]),
                    ["auto_op", "auto_sales", "auto_csr"].includes(
                      _vm.currentKey
                    )
                      ? [
                          _c(
                            "el-radio",
                            { attrs: { label: "englishNamePlusChineseName" } },
                            [_vm._v(_vm._s(_vm.$t("Tool.EnglishAndChinese")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "chineseNamePlusEnglishName" } },
                            [_vm._v(_vm._s(_vm.$t("Tool.ChineseAndEnglish")))]
                          )
                        ]
                      : [
                          _c("el-radio", { attrs: { label: "code" } }, [
                            _vm._v(_vm._s(_vm.$t("Tool.Code")))
                          ]),
                          !["auto_7", "auto_8", "auto_railway"].includes(
                            _vm.currentKey
                          )
                            ? _c(
                                "el-radio",
                                { attrs: { label: "shortName" } },
                                [_vm._v(_vm._s(_vm.$t("Tool.ShortName")))]
                              )
                            : _vm._e(),
                          _c(
                            "el-radio",
                            { attrs: { label: "sortNamePlusChineseName" } },
                            [_vm._v(_vm._s(_vm.$t("Tool.CodeAndChinese")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { label: "sortNamePlusEnglishName" } },
                            [_vm._v(_vm._s(_vm.$t("Tool.CodeAndEnglish")))]
                          ),
                          Object.keys(_vm.currentOpt).includes(
                            "shortNamePlusChineseName"
                          )
                            ? _c(
                                "el-radio",
                                {
                                  attrs: { label: "shortNamePlusChineseName" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Tool.ShortNameAndChinese"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.currentKey === "auto_accountId"
                            ? [
                                _c("div", { staticStyle: { width: "1px" } }),
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { overflow: "unset" },
                                    attrs: {
                                      label: "customerSupplierNoChineseName"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Tool.CustomerSupplierNoChinese")
                                      )
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm.currentKey === "auto_6"
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: _vm.$t(
                                      "Tool.threeCharacterCodeTooltip"
                                    ),
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticStyle: { overflow: "unset" },
                                      attrs: { label: "threeCharacterCode" }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("Tool.threeCharacterCode")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentKey === "auto_0"
                            ? _c(
                                "el-radio",
                                {
                                  staticStyle: { overflow: "unset" },
                                  attrs: { label: "customerNoChineseName" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Tool.CustomerNoChinese"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          [
                            "auto_1",
                            "auto_2",
                            "auto_3",
                            "auto_4",
                            "auto_9",
                            "auto_10",
                            "auto_11"
                          ].includes(_vm.currentKey)
                            ? _c(
                                "el-radio",
                                {
                                  staticStyle: { overflow: "unset" },
                                  attrs: { label: "supplierNoChineseName" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Tool.SupplierNoChinese"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                  ]
            ],
            2
          )
        ],
        1
      ),
      _c("el-form-item", {
        staticClass: "label-bold",
        attrs: { label: _vm.$t("Message.AffiliatedBranchStyle") }
      }),
      _c(
        "el-form-item",
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.ownedBranchStyle,
                callback: function($$v) {
                  _vm.ownedBranchStyle = $$v
                },
                expression: "ownedBranchStyle"
              }
            },
            [
              _c(
                "el-radio",
                { staticStyle: { width: "35%" }, attrs: { label: "level" } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("Message.DisplayByOrganizationalStructure"))
                  )
                ]
              ),
              _c("el-radio", { attrs: { label: "list" } }, [
                _vm._v(_vm._s(_vm.$t("Message.AllDisplay")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "label-bold",
          attrs: { label: _vm.$t("CargoMsg.Cargo_SOPWorkTaskBoard") }
        },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "#E6A23C", "line-height": "28px" }
            }),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#E6A23C",
                  "white-space": "nowrap",
                  overflow: "hidden",
                  "text-overflow": "ellipsis"
                },
                attrs: { title: _vm.$t("Message.CloseRefreshNeedMannulUpdate") }
              },
              [_vm._v(_vm._s(_vm.$t("Message.CloseRefreshNeedMannulUpdate")))]
            )
          ])
        ]
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: {
            label: _vm.$t("Message.RefreshRule"),
            "label-width": "120px",
            "label-position": "right"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c("el-checkbox", {
                model: {
                  value: _vm.sopWorkTaskBoardSetting.disabledAutoRefresh,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sopWorkTaskBoardSetting,
                      "disabledAutoRefresh",
                      $$v
                    )
                  },
                  expression: "sopWorkTaskBoardSetting.disabledAutoRefresh"
                }
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#666666",
                    "white-space": "nowrap",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                    "margin-left": "10px"
                  },
                  attrs: { title: _vm.$t("Message.HomePageNotRefreshData") }
                },
                [_vm._v(_vm._s(_vm.$t("Message.HomePageNotRefreshData")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: {
            label: _vm.$t("Message.NodeRecord"),
            "label-width": "120px",
            "label-position": "right"
          }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.sopWorkTaskBoardSetting.keepSelectedNode,
                callback: function($$v) {
                  _vm.$set(_vm.sopWorkTaskBoardSetting, "keepSelectedNode", $$v)
                },
                expression: "sopWorkTaskBoardSetting.keepSelectedNode"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.DisplayLastClickNode")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: { label: " ", "label-width": "120px" }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.sopWorkTaskBoardSetting.keepQueryCondition,
                callback: function($$v) {
                  _vm.$set(
                    _vm.sopWorkTaskBoardSetting,
                    "keepQueryCondition",
                    $$v
                  )
                },
                expression: "sopWorkTaskBoardSetting.keepQueryCondition"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.RetainQueryCondition")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: { label: _vm.$t("Message.TaskBoard"), "label-width": "120px" }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.sopWorkTaskBoardSetting.resetQueryOnTemplateSwitch,
                callback: function($$v) {
                  _vm.$set(
                    _vm.sopWorkTaskBoardSetting,
                    "resetQueryOnTemplateSwitch",
                    $$v
                  )
                },
                expression: "sopWorkTaskBoardSetting.resetQueryOnTemplateSwitch"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.DoOfQueryResultsTemplates")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "label-bold",
          attrs: { label: _vm.$t("CargoMsg.Cargo_WarnTodoList") }
        },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "#E6A23C", "line-height": "28px" }
            }),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#E6A23C",
                  "white-space": "nowrap",
                  overflow: "hidden",
                  "text-overflow": "ellipsis"
                },
                attrs: { title: _vm.$t("Message.CloseRefreshNeedMannulUpdate") }
              },
              [_vm._v(_vm._s(_vm.$t("Message.CloseRefreshNeedMannulUpdate")))]
            )
          ])
        ]
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: {
            label: _vm.$t("Message.RefreshRule"),
            "label-width": "120px",
            "label-position": "right"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c("el-checkbox", {
                model: {
                  value: _vm.preWarningSetting.disabledAutoRefresh,
                  callback: function($$v) {
                    _vm.$set(_vm.preWarningSetting, "disabledAutoRefresh", $$v)
                  },
                  expression: "preWarningSetting.disabledAutoRefresh"
                }
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#666666",
                    "white-space": "nowrap",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                    "margin-left": "10px"
                  },
                  attrs: { title: _vm.$t("Message.HomePageNotRefreshData") }
                },
                [_vm._v(_vm._s(_vm.$t("Message.HomePageNotRefreshData")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: {
            label: _vm.$t("Message.NodeRecord"),
            "label-width": "120px",
            "label-position": "right"
          }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.preWarningSetting.keepSelectedNode,
                callback: function($$v) {
                  _vm.$set(_vm.preWarningSetting, "keepSelectedNode", $$v)
                },
                expression: "preWarningSetting.keepSelectedNode"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.DisplayLastClickNode")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: { label: " ", "label-width": "120px" }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.preWarningSetting.keepQueryCondition,
                callback: function($$v) {
                  _vm.$set(_vm.preWarningSetting, "keepQueryCondition", $$v)
                },
                expression: "preWarningSetting.keepQueryCondition"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.RetainQueryCondition")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: { label: _vm.$t("Message.AlertNode"), "label-width": "120px" }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.preWarningSetting.resetQueryOnTemplateSwitch,
                callback: function($$v) {
                  _vm.$set(
                    _vm.preWarningSetting,
                    "resetQueryOnTemplateSwitch",
                    $$v
                  )
                },
                expression: "preWarningSetting.resetQueryOnTemplateSwitch"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.DoOfQueryResultsTemplates")))]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "label-bold",
          attrs: {
            label: _vm.$t("CargoMsg.PriorityDisplay"),
            "label-width": "120px"
          }
        },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "#E6A23C", "line-height": "28px" }
            }),
            _c(
              "span",
              {
                staticStyle: {
                  color: "#E6A23C",
                  "white-space": "nowrap",
                  overflow: "hidden",
                  "text-overflow": "ellipsis"
                },
                attrs: { title: _vm.$t("CargoMsg.WhenTheNodeAllDisplayed") }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.WhenTheNodeAllDisplayed")))]
            )
          ])
        ]
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "-10px" },
          attrs: {
            label: _vm.$t("CargoMsg.DefaultDisplay"),
            "label-width": "120px"
          }
        },
        [
          _c("cargo-advance-select", {
            staticStyle: { width: "250px" },
            attrs: {
              filterable: "",
              multiple: true,
              placeholder: _vm.$t("CargoMsg.PrioritizationSettings"),
              "callback-method-type": "value",
              "static-options": _vm.PRIORITIES,
              "default-multiple-value": _vm.toArray(
                _vm.dataPriorityDisplaySetting.defaultDisplay
              ),
              "tag-name": "name",
              "tag-value": "code"
            },
            on: {
              parentCallBack: function(value) {
                _vm.dataPriorityDisplaySetting.defaultDisplay = _vm.toTxt(value)
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "save-btn" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
            [_vm._v(_vm._s(_vm.$t("Tool.Save")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }